import flickityCarousels from '../components/flickity-carousels.js';

window.addEventListener('DOMContentLoaded', flickityCarousels, false);
